import { Box, Checkbox, DialogTitle, FormControlLabel, List, ListItem, ListItemText, Typography } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

export const AutoReleaseDialogTitle = ({ title }) => (
  <Box sx={{ bgcolor: "#ebf7ff", px: 3, pt: 3, pb: 1.5 }}>
    <DialogTitle sx={{ p: 0 }}>
      <Box display="flex" alignItems="center" gap={1.5}>
        <AutoFixHighIcon sx={{ color: "#0054A5" }} />
        <Typography variant="h6" fontWeight="bold" color="#1f2937">
          {title}
        </Typography>
      </Box>
    </DialogTitle>
  </Box>
);

// "Select all" over the orders that can be released (no unsaved edits).
export const SelectAllCheckbox = ({ selection }) => {
  const { releasableOrdnames, selectedOrdnames, setSelectedOrdnames } = selection;
  const allSelected = releasableOrdnames.length > 0 && releasableOrdnames.every((o) => selectedOrdnames.includes(o));
  return (
    <Box mb={1}>
      <FormControlLabel
        control={
          <Checkbox
            checked={allSelected}
            indeterminate={selectedOrdnames.length > 0 && !allSelected}
            onChange={(e) => setSelectedOrdnames(e.target.checked ? releasableOrdnames : [])}
            size="small"
          />
        }
        label={
          <Typography variant="body2" fontWeight={600}>
            בחר הכל
          </Typography>
        }
      />
    </Box>
  );
};

// Orders listed with a trailing detail, e.g. "SO1 (customer): reason".
export const OrdersResultList = ({ orders, detail, separator = ": ", colors }) => (
  <Box bgcolor={colors.bg} borderRadius={2} border={`1px solid ${colors.border}`} px={2} py={1} sx={colors.sx}>
    <List dense disablePadding>
      {orders.map((r) => (
        <ListItem key={r.ordname} disablePadding sx={{ py: 0.3 }}>
          <ListItemText
            primary={
              <>
                <strong>{r.ordname}</strong>
                {r.custName && ` (${r.custName})`}
                {separator}
                {detail(r)}
              </>
            }
            primaryTypographyProps={{ fontSize: colors.fontSize || "0.85rem", color: colors.text }}
          />
        </ListItem>
      ))}
    </List>
  </Box>
);

export const ERROR_LIST_COLORS = { bg: "#fef2f2", border: "#fecaca", text: "#7f1d1d" };
export const SUCCESS_LIST_COLORS = { bg: "#f0faf4", border: "#c6ecd4", text: "#1f2937" };

export const SkippedOrdersList = ({ skipped, hasToRelease }) => (
  <Box mt={hasToRelease ? 3 : 1}>
    <Typography variant="subtitle2" fontWeight={700} color="#6b7280" mb={1}>
      דולגו {skipped.length} הזמנות
    </Typography>
    <OrdersResultList
      orders={skipped}
      detail={(s) => s.reason}
      colors={{ ...ERROR_LIST_COLORS, fontSize: "0.82rem", sx: { maxHeight: 220, overflowY: "auto" } }}
    />
  </Box>
);
